export TimeSlotCalendar from './TimeSlotCalendar.jsx';
export * from './redux/calendar';


/** WEBPACK FOOTER **
 ** ./client/shared/packages/TimeSlotCalendar/src/index.js
 **/